export class HttpError extends Error {
    constructor(axiosError) {
        var _a, _b;
        super(axiosError.message);
        this.name = 'HttpError';
        this.axiosError = axiosError;
        this.apiErrors = (_a = axiosError === null || axiosError === void 0 ? void 0 : axiosError.response) === null || _a === void 0 ? void 0 : _a.data.errors;
        this.httpStatus = (_b = axiosError.response) === null || _b === void 0 ? void 0 : _b.status;
        this.message = axiosError.message;
    }
}
export const isHttpError = (err) => {
    return (err instanceof Error &&
        'axiosError' in err &&
        'apiErrors' in err &&
        'httpStatus' in err &&
        err.name === 'HttpError');
};
